import React from 'react';
import styled from 'styled-components';
import * as api from '../../../api';

const AdminFieldContainer = styled.div`
    background-color: #F6F6F6;
    padding: 20px;
    padding-bottom: 0;
    border-radius: 20px;
    margin: 10px 0;
`

const CompanyAdminFields = (props) => {

    const [values, setValues] = React.useState({});

    React.useEffect(()=>{
        setValues(props.participation.data);
    },[props.participation])

    function onSubmit(e){
        e.preventDefault();

        api.SetCompanyAdminFields({
            participationId: props.participation._id,
            numTableOULienZoom: e.target.numTableOULienZoom.value,
            description_admin_fr: '',// e.target.description_admin_fr.value,
            description_admin_en: '',//e.target.description_admin_en.value,
            entreprise_validee: e.target.entreprise_validee.checked,
        }).then((response) => {
            console.log(response.data);
            props.onFinnish();
        }).catch((error) => {
            console.log(error);
        });
    }

    return (
        <div>
            <br/>
            <button onClick={props.onBack} className=''>← Retour</button><br/>
            <form onSubmit={onSubmit}>
                <AdminFieldContainer>
                    Champs Administrateur<br/><br/>
                    <label>
                        Numéro de table ou lien zoom :<br/>
                        <input type="text" name="numTableOULienZoom" placeholder="Numéro de table ou lien zoom" defaultValue={values?.numTableOULienZoom} />
                    </label>
                    {/* Description saisie par l'utilisateur :<br/>
                    <p className='thin preformatted'>{props.userDescription}</p><br/>
                    <label>
                        Description FR :<br/>
                        <textarea type="text" name="description_admin_fr" placeholder="Description FR" defaultValue={values?.description_admin_fr} />
                    </label>
                    <label>
                        Description EN :<br/>
                        <textarea type="text" name="description_admin_en" placeholder="Description EN" defaultValue={values?.description_admin_en} />
                    </label> */}
                    <label>
                        Entreprise validée : <input type="checkbox" name="entreprise_validee" defaultChecked={values?.entreprise_validee} />
                    </label>
                </AdminFieldContainer>
                <br/>
                <input className='centered' type="submit" value="Enregistrer" />
            </form>
        </div>
    );
};

export default CompanyAdminFields;